<script>
  const icon_interestrate = "/assets_default/icons/interestrate.svg"
  const icon_commission = "/assets_default/icons/commission.svg"
  const icon_banking = "/assets_default/icons/banking.svg"

  const list = [
    {
      icon: icon_interestrate,
      title: "金利",
      number: [{
        label: "普通預金金利",
        num: "0.5",
        text: "%"
      }]
    },
    {
      icon: icon_commission,
      title: "振込手数料",
      number: [{
        label: "自行への振込",
        num: "0",
        text: "円"
      },{
        label: "他行への振込",
        num: "130",
        text: "円"
      }]
    },
    {
      icon: icon_banking,
      title: "サービス利用料",
      number: [{
        label: "基本利用料",
        num: "0",
        text: "円"
      }]
    }
  ]
</script>

<div class="figure-section">
  <p class="align:center figure-section-title">デジタルバンクならではの<br class="show:sp">お得な金利・手数料</p>
  <div class="figure-inner">
    {#each list as item}
    <div class="figure-item">
      <div class="icon">
        <img src={item.icon} alt="イメージアイコン">
      </div>
      <div class="figure-item-textarea">
        <p class="owd-heading:02 align:center figure-textarea-title"><strong>{item.title}</strong></p>
        <div class="nuumber-flex">
          {#each item.number as n}
          <div>
            <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:12">
              <p class="owd-label:en:large owd-servicesticker-label">{n.label}</p>
            </div>
            <p class="figure-number-text align:center biz-text:64"><strong>{@html n.num}<small>{@html n.text}</small></strong></p>
          </div>
          {/each}
        </div>
      </div>
    </div>
    {/each}
  </div>
</div>

<style lang="scss">
.figure{
  &-section{
    padding: 64px 40px;
    &-title{
      @include g.owd-typography($fz: 'heading-2', $line-height-px: 32, $letter-spacing-tracking: 25, $font-weight: 600);
      margin-bottom: 40px;
    }
  }
  &-inner{
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(3,1fr);
  }
  &-item{
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding-bottom: 40px;
    &::before{
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      height: calc(100% - 30px);
      background-color: var(--primary-white);
      z-index: 0;
    }
    .icon{
      background-color: var(--primary-white);
      aspect-ratio: 1;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 60px;
      position: relative;
      z-index: 1;
      margin-bottom: 10px;
      img{
        width: 24px;
      }
    }
    &-textarea{
      position: relative;
      z-index: 1;
      .figure-textarea-title{
        @include g.owd-typography($fz: 'heading-3', $line-height-px: 32, $letter-spacing-tracking: 25, $font-weight: 600);
        padding: 2px 0;
        margin-bottom: 24px;
      }
      .nuumber-flex{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        .figure-number-text{
          letter-spacing: -4.16px;
          font-family: g.$enbold;
          small{
            display: inline-block;
            margin-left: 2px;
            @include g.owd-typography($fz: 'text-4', $line-height-px: 28, $letter-spacing-tracking: 25, $font-weight: 600);
          }
        }
      }
    }
  }
  @include g.mobile () {
    &-section{
      padding: 48px 24px;
      &-title{
        @include g.owd-typography($fz: 'heading-3', $line-height-px: 32, $letter-spacing-tracking: 25, $font-weight: 600);
        padding: 2px 0;
        margin-bottom: 24px;
      }
    }
    &-inner{
      grid-template-columns: 1fr;
    }
    &-item{
      padding-bottom: 24px;
      .icon{
        margin-bottom: 1px;
      }
      &-textarea{
        .figure-textarea-title{
          @include g.owd-typography($fz: 'heading-1', $line-height-px: 28, $letter-spacing-tracking: 50, $font-weight: 600);
          padding: 1.5px 0;
          margin-bottom: 16px;
        }
        .nuumber-flex{
          gap: 12px;
        }
      }
    }
  }
}
</style>
